import { render, staticRenderFns } from "./DetailsAddToWishList.vue?vue&type=template&id=2d3f3dac&scoped=true&"
import script from "./DetailsAddToWishList.vue?vue&type=script&lang=ts&"
export * from "./DetailsAddToWishList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3f3dac",
  null
  
)

export default component.exports